// Selector de variables de marca para los prompts de StyleManager.
// Qué hace: renderiza los grupos de tokens ({{brand}}, {{topic}}, …) como botones;
//   al hacer click inserta el token en el textarea activo via onInsert. Bloque
//   presentacional reutilizado por los dos modales (crear AI / editar prompts).
// Qué exporta: PROMPT_VARIABLES (datos), VariablePicker (componente).
// Qué recibe: onInsert(token) — callback que inserta el token; helpText opcional.
// Quién lo usa: components/StyleManager.tsx.

import { SectionLabel, VarButton, Hint, GroupLabel } from './styled';

// Variables de marca disponibles para inyectar en los prompts. Se reemplazan
// por datos reales del brand en tiempo de generación.
export const PROMPT_VARIABLES: { group: string; items: { token: string; label: string }[] }[] = [
  { group: 'Brand', items: [
    { token: '{{brand}}', label: 'Name' },
    { token: '{{topic}}', label: 'Message/topic' },
    { token: '{{industry}}', label: 'Industry' },
  ]},
  { group: 'Brand details', items: [
    { token: '{{services}}', label: 'Services' },
    { token: '{{audience}}', label: 'Audience' },
    { token: '{{positioning}}', label: 'Positioning' },
    { token: '{{identity}}', label: 'Identity' },
    { token: '{{emotionalBenefits}}', label: 'Emotional benefits' },
    { token: '{{personality}}', label: 'Personality' },
    { token: '{{story}}', label: 'Brand story' },
  ]},
  { group: 'Visual', items: [
    { token: '{{colors}}', label: 'Colors' },
    { token: '{{fonts}}', label: 'Fonts' },
  ]},
  { group: 'Contact', items: [
    { token: '{{phone}}', label: 'Phone' },
    { token: '{{whatsapp}}', label: 'WhatsApp' },
    { token: '{{email}}', label: 'Email' },
    { token: '{{address}}', label: 'Address' },
    { token: '{{hours}}', label: 'Hours' },
    { token: '{{website}}', label: 'Website' },
  ]},
];

interface VariablePickerProps {
  helpText: string;
  onInsert: (token: string) => void;
}

export function VariablePicker({ helpText, onInsert }: VariablePickerProps) {
  return (
    <>
      <SectionLabel>Insert variable</SectionLabel>
      <Hint>{helpText}</Hint>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {PROMPT_VARIABLES.map((grp) => (
          <div key={grp.group}>
            <GroupLabel>{grp.group}</GroupLabel>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
              {grp.items.map((v) => (
                <VarButton key={v.token} type="button" title={v.token} onMouseDown={(e) => e.preventDefault()} onClick={() => onInsert(v.token)}>{v.label}</VarButton>
              ))}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
